import { Layout } from 'react-grid-layout';

export const parseWorkspaceLayoutOrder = (cols: number, layout: Layout[]) => {
  return layout
    .map(({ i, x, y }) => ({ i, order: y * cols + x }))
    .sort((a, b) => (a.order > b.order ? 1 : -1))
    .map(({ i }) => i);
};
